import {ErrorMessage, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import * as Yup from 'yup'

import {StateParamsModel} from 'src/app/modules/common/Model'
import * as formDownloadRedux from '../index'

import Modal from 'rsuite/Modal'

import * as categoriesRedux from 'src/app/modules/cms'
import * as categoryTypeRedux from 'src/app/modules/common'
import * as categoriesRedux1 from 'src/app/modules/formsAndDownload/components/formsDownload'
import FormInputMediaManager from 'src/cms/helpers/components/forms/FormInputMediaManager'
import FormRadio from 'src/cms/helpers/components/forms/FormRadio'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import {imageBaseUrl} from 'src/cms/helpers/constants'

import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import * as setting from 'src/app/modules/siteSettings/components/settings'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import {IformDownloadCategoryState} from '../index'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

let FORM_VALIDATION = Yup.object().shape({
  title: Yup.string().required('Name is required'),
  status: Yup.string().required('Status is required'),
  published_date: Yup.string().required('Publish Date is required'),
})

const AddFormsAndDownload = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.formsAndDownload)
  const [downloadCategory, setDownloadCategory] = useState<any>()
  const [formCategory, setFormCategory] = useState<any>()
  const [formsdownloadCategory, setFormsDownloadCategory] = useState<any>()
  const [categoryList, setCategoryList] = useState<any>()
  const [applicationName, setApplicationName] = useState('')
  const [categoryName, setCategoryName] = useState('')
  const isCategoryNameRequired = checkBackendSetting('isCategoryNameRequired')

  if (isCategoryNameRequired) {
    FORM_VALIDATION = FORM_VALIDATION.shape({
      categoryId: Yup.string().required('Category Name is required'),
    })
  }
  const statusOptions = [
    {label: 'Active', value: 'Active'},
    {label: 'Inactive', value: 'Inactive'},
  ]

  const {
    data: {categoryType},
  } = useSelector((state: any) => state.categoryType)

  const {
    data: {category},
    formDownloadCategory,
  } = useSelector((state: any) => state.categories)

  const downloadCategoryOption = category?.map((item: {[key: string]: string}) => ({
    label: item.name,
    value: item.id,
  }))

  const downloadCategoryTypeOption = formDownloadCategory?.map((item: {[key: string]: any}) => ({
    label: item.name,
    value: item?.typeId?.id,
  }))

  useEffect(() => {
    dispatch(categoryTypeRedux.action.getCategoryType())
  }, [])

  useEffect(() => {
    const merchantCatType = categoryType?.filter(
      (item: {[key: string]: string}) => item.system_name === 'download'
    )
    const formCategoryType = categoryType?.filter(
      (item: {[key: string]: string}) => item.system_name === 'form'
    )
    setDownloadCategory(merchantCatType[0]?.id)
    setFormCategory(formCategoryType[0]?.id)
  }, [categoryType])

  useEffect(() => {
    if (!isEmpty(downloadCategory) && !isEmpty(formCategory)) {
      dispatch(
        categoriesRedux.categories.actions.getformDownloadCmsCategories(
          downloadCategory,
          formCategory
        )
      )
    }
  }, [downloadCategory])

  const categoryTypeData: IformDownloadCategoryState = useSelector(
    (state: any) => state.formsAndDownloadCategory
  )
  useEffect(() => {
    dispatch(categoriesRedux1.actions.getAllFormsDownloadCategory())
  }, [])

  useEffect(() => {
    const filterformsAndDownloadCategory = categoryTypeData?.data?.categoryType?.filter(
      (item: {[key: string]: string}) =>
        item.system_name === 'download' || item?.system_name === 'form'
    )
    setFormsDownloadCategory(filterformsAndDownloadCategory)
  }, [])

  const categoryOptions1 = formsdownloadCategory?.map((item: {[key: string]: string}) => ({
    label: item.display_name,
    value: item.id,
  }))

  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  const showInterestTitle =
    settingTypeData?.data?.setting?.filter((d: any) => d?.name === 'showInterestTitle')[0]
      ?.value === '1'
      ? true
      : false

  const showDownloadCategoryOnlyOnAddDownloadsForm =
    settingTypeData?.data?.setting?.filter(
      (d: any) => d?.name === 'showDownloadCategoryOnlyOnAddDownloadsForm'
    )[0]?.value === '1'

  useEffect(() => {
    dispatch(setting.actions.getSettingType())
  }, [])

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Application Credentials']?.map((item: any) => {
          if (item?.name === 'applicationName') {
            setApplicationName(item?.value)
          }
        })
    }
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Application Credentials']?.map((item: any) => {
          if (item?.name === 'Show Category') {
            setCategoryName(item?.value)
          }
        })
    }
  }, [settingTypeData])

  useEffect(() => {
    if (!isEmpty(downloadCategory)) {
      dispatch(categoriesRedux.categories.actions.getSpecificCmsCategories(downloadCategory))
    }
  }, [downloadCategory])

  useEffect(() => {
    if (success) {
      dispatch(formDownloadRedux?.actions.getFormsDownload(params))
      isEmpty(editSelectedData)
        ? toast.success('Form added successfully')
        : toast.success('Form edited successfully')
      dispatch(formDownloadRedux?.actions?.resetFormsDownload())
      handleClose()
    }
  }, [success])

  const isMultiLanguage = checkMultiLanguage()

  const hideAttachFile = checkBackendSetting('showAttachedFile')

  return (
    <div className='modal-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} Form And Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                title: '',
                title_np: '',
                attached_file_title: '',
                attached_file: '',
                published_date: '',
                categoryTypeId: '',
                categoryId: '',
                slug: '',
                status: '',
                image: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: any) => {
                const formData = {
                  ...values,
                  categoryId: values?.categoryId,
                  categoryTypeId: values?.categoryTypeId,
                  slug: !isEmpty(editSelectedData)
                    ? editSelectedData?.slug
                    : values?.title.replace(/\s/g, '-').toLowerCase(),
                  status: values?.status === 'Active' ? true : false,
                }
                if (!isEmpty(editSelectedData)) {
                  dispatch(
                    formDownloadRedux.actions.updateFormsDownload(formData, editSelectedData?.id)
                  )
                } else {
                  dispatch(formDownloadRedux.actions.addFormsDownload(formData))
                }
              }}
            >
              {({touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = [
                      'id',
                      'title',
                      'title_np',
                      'attached_file_title',
                      'attached_file',
                      'published_date',
                      'slug',
                      'status',
                      'image',
                      'categoryTypeId',
                      'categoryId',
                    ]
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                    setFieldValue(
                      'status',
                      editSelectedData?.status === true ? 'Active' : 'Inactive',
                      false
                    )
                  }
                }, [])

                return (
                  <Form>
                    <div className='card-body border-top pt-5'>
                      <div className='row'>
                        {showDownloadCategoryOnlyOnAddDownloadsForm ? (
                          <div className='col-md-6 col-xs-12'>
                            <FormSelect
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Please select'
                              label='Category'
                              name='categoryId'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              options={downloadCategoryOption}
                              values={values}
                              setFieldValue={setFieldValue}
                              required={isCategoryNameRequired}
                            />
                          </div>
                        ) : (
                          <div className='col-md-6 col-xs-12'>
                            <FormSelect
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Please select'
                              label='Category Name'
                              name='categoryId'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              // options={downloadCategoryTypeOption}
                              options={downloadCategoryOption}
                              values={values}
                              setFieldValue={setFieldValue}
                              required={isCategoryNameRequired}
                            />
                          </div>
                        )}
                      </div>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder={isMultiLanguage ? 'Enter Name' : 'Enter Name (EN)'}
                            label={isMultiLanguage ? 'Title' : 'Title (EN)'}
                            name='title'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required
                          />
                        </div>
                        {isMultiLanguage ? null : (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Name (NP)'
                              label='Title (NP)'
                              name='title_np'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        )}

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder={
                              isMultiLanguage ? 'Attached file title' : 'Attached file title (En)'
                            }
                            label={
                              isMultiLanguage ? 'Attached file title' : 'Attached file title (EN)'
                            }
                            name='attached_file_title'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        {hideAttachFile && (
                          <div className='col-md-6 col-xs-12'>
                            <FormInputMediaManager
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              label='Attached File'
                              name='attached_file'
                              setFieldValue={setFieldValue}
                              value={values?.attached_file}
                              buttonName='Add Attach File '
                            />
                            {!isEmpty(values?.attached_file) ? (
                              <>
                                <li className='listing'>
                                  <div className='thumbImageBlock'>
                                    <button
                                      type='button'
                                      title='Remove'
                                      className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                      onClick={() => {
                                        setFieldValue('attached_file', '')
                                      }}
                                      data-cy='modal-thumbnail-remove'
                                    >
                                      Delete
                                    </button>

                                    <img
                                      className='thumbImage w-100 h-100'
                                      src={`${
                                        !imageBaseUrl.includes('framework')
                                          ? imageBaseUrl + '/framework'
                                          : imageBaseUrl
                                      }/${values?.attached_file}`}
                                      alt=''
                                    />
                                  </div>
                                </li>
                              </>
                            ) : null}
                          </div>
                        )}

                        <div className='col-md-6 col-xs-12'>
                          <FormInputMediaManager
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            label='Image'
                            name='image'
                            setFieldValue={setFieldValue}
                            value={values?.image}
                            buttonName='Add Attach Image '
                          />
                          {!isEmpty(values?.image) ? (
                            <>
                              <li className='listing'>
                                <div className='thumbImageBlock'>
                                  <button
                                    type='button'
                                    title='Remove'
                                    className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                    onClick={() => {
                                      setFieldValue('image', '')
                                    }}
                                    data-cy='modal-thumbnail-remover'
                                  >
                                    Delete
                                  </button>

                                  <img
                                    className='thumbImage w-100 h-100'
                                    src={`${
                                      !imageBaseUrl.includes('framework')
                                        ? imageBaseUrl + '/framework'
                                        : imageBaseUrl
                                    }/${values?.image}`}
                                    alt=''
                                  />
                                </div>
                              </li>
                            </>
                          ) : null}
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='date'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter publish date'
                            label='Publish Date'
                            name='published_date'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Slug'
                            label='Slug'
                            name='slug'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            disabled={true}
                            value={
                              !isEmpty(editSelectedData)
                                ? editSelectedData?.slug
                                : values?.title.replace(/\s/g, '-').toLowerCase()
                            }
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <label className='form-label fw-bolder text-dark fs-6 required'>
                            Status
                          </label>

                          <div className='d-flex ms-5'>
                            {statusOptions?.map((status: {label: string; value: string}) => (
                              <FormRadio
                                containerClassName=''
                                label='Select Status'
                                name='status'
                                type='radio'
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                required={true}
                                checkBoxText={status?.label}
                                value={status?.value}
                              />
                            ))}
                          </div>
                          <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
                            <ErrorMessage
                              name='status'
                              component='div'
                              className='field-error-message'
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddFormsAndDownload
